<template>
  <div>
    <div class="results-page">
      <div class="bg"></div>
      <div class="content">
        <img
          class="results"
          src="./../../assets/microscope/results.png"
          alt=""
        />
        <div class="topTitle">恭喜您已完成全部线上实操考核</div>
        <div class="pic">{{ petScoreData.score }}</div>
        <div class="pictxt">您的总成绩</div>
        <div class="pictxtall">(满分100分)</div>
        <div class="detail">
          <div class="text">
            <!-- <div>显微镜操作判读考核</div> -->
            <div>镜下读片</div>
            <div>{{ petScoreData.slideScore }}</div>
          </div>
          <div class="text">
            <!-- <div>诊疗思路考核</div> -->
            <div>模拟接诊</div>
            <div>{{ petScoreData.petScore }}</div>
          </div>
        </div>
        <!-- <div class="detailFooter">
          * 线上实操总成绩=显微镜操作判读考核分数x50%+诊疗思路考核分数x50%
        </div> -->
        <div class="detailFooter">
          * 线上实操总成绩=镜下读片分数x50%+模拟接诊分数x50%
        </div>
      </div>
      <div class="footer">
        <!-- <div @click="handleBtn(true)" class="btn">确认</div> -->

        <div
          @click="handleBtn(1)"
          v-if="
            (!shareTimes || !studyTimes) &&
            initData.remainingTimes == 0 &&
            !isEnd
          "
          class="btn"
        >
          领取再次答题机会
        </div>
        <div
          @click="handleBtn(2)"
          v-if="
            (!(!shareTimes || !studyTimes) || initData.remainingTimes != 0) &&
            !isEnd
          "
          class="btn"
        >
          再次尝试答题
        </div>
        <div @click="handleBtn(3)" class="btns">查看答案</div>
        <div @click="handleBtn(4)" v-if="!isEnd" class="btns">再次复习巩固</div>
      </div>
    </div>
    <div class="mask" v-if="errorShow"></div>
    <div class="dialog" v-if="errorShow">
      <div class="text mt130">敬请期待</div>
      <!-- <div class="text">8.1号可查看</div> -->
      <div class="text">暂未开放</div>
      <div @click="handleCloseError" class="btn">确认</div>
    </div>
    <div class="zantingbox" v-show="isPause">
      <div class="main">
        <img src="./../../assets/home/daan.png" />
        <div class="zantingbox-suspend">选择答案</div>
        <div class="btn" @click="handleContinueExam(1)">镜下读片考核答案</div>
        <div class="btn" @click="handleContinueExam(2)">模拟接诊考核答案</div>
      </div>
    </div>
    <mi-xin></mi-xin>
  </div>
</template>
<script>
import {
  getSummaryScore,
  getHighestSummaryScore,
  isEnd,
  examExtractQueryExtraTimes,
  getIndexUserData,
  getPaperAndAnswer,
} from "@/api/system/exam";
import MiXin from "../mixins/index";
import { login } from "@/api/system/login";
import wx from "weixin-js-sdk";
import { setToken } from "@/utils/cookie";
export default {
  components: {
    MiXin,
    // TimeNum,
  },
  data() {
    return {
      isEnd: false,
      errorShow: false,
      petScoreData: [],
      isPause: false,
      shareTimes: 0,
      studyTimes: 0,
      initData: null,
    };
  },
  created() {
    if (this.$route.query.hospitalName) {
      this.getInit();
    } else {
      this.init();
      this.getQueryExtraTimesData();
    }
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goPageBefore, false);
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.goPageBefore, false);
  },
  methods: {
    goPageBefore() {
      wx.miniProgram.navigateBack({});
      // wx.miniProgram.navigateTo({ url: "/pages/my/my" });
    },
    // 初始化登录
    async getInit() {
      let data;
      data = {
        hospitalName: this.$route.query.hospitalName,
        nickName: this.$route.query.nickName,
        sign: this.$route.query.sign,
        timestamp: this.$route.query.timestamp,
        userId: this.$route.query.userId,
      };
      await login(data).then((res) => {
        setToken(res.data.access_token);
      });
      this.init();
      this.getQueryExtraTimesData();
    },
    //诊疗结果
    init() {
      isEnd().then((res) => {
        if (res.data.code === 0) {
          this.isEnd = res.data.data;
        }
      });
      if (this.$route.query.hospitalName) {
        getHighestSummaryScore().then((res) => {
          if (res.data.code === 0) {
            this.petScoreData = res.data.data;
          }
        });
      } else {
        getSummaryScore().then((res) => {
          if (res.data.code === 0) {
            this.petScoreData = res.data.data;
          }
        });
      }
    },
    //查询额外考试次数
    getQueryExtraTimesData() {
      getIndexUserData().then((res) => {
        this.initData = res.data.data;
      });
      examExtractQueryExtraTimes().then((res) => {
        this.studyTimes = res.data.studyTimes || 0;
        this.shareTimes = res.data.shareTimes || 0;
      });
    },

    // 关闭弹出框
    handleCloseError() {
      this.errorShow = false;
    },
    handleContinueExam(type) {
      if (type === 1) {
        // this.$router.push({
        //   path: "/microscope/answerAll",
        // });
        this.$router.push("/microscope/answer");
      } else {
        getPaperAndAnswer().then((res) => {
          if (res.data.code === 0) {
            this.$router.push({
              path: "/treat/pdf",
              query: {
                url: res.data.data[0].answer,
              },
            });
          }
        });
        // this.$router.push({
        //   path: "/treat/answer",
        //   query: {
        //     num: this.petScoreData.petScore,
        //   },
        // });
      }
    },
    // 点击按钮
    handleBtn(val) {
      if (val == 1) {
        wx.miniProgram.navigateTo({
          url: "/pages/knowledge/numberAnswers?type=2",
        });

        // wx.miniProgram.navigateTo({ url: "/pages/my/my" });
      } else if (val == 2) {
        // wx.miniProgram.navigateBack({});
        this.$router.replace({
          path: "/index/home2026",
          query: {
            isLogin: false,
          },
        });
      } else if (val == 3) {
        this.isPause = true;
      } else if (val == 4) {
        wx.miniProgram.navigateTo({
          url: "/pages/knowledge/ktqd?type=2",
        });
        // this.errorShow = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.results-page {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 120px;
  background-image: url("./../../assets/home/cbbj.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .bg {
    height: 90px;
  }

  .content {
    width: 653px;
    height: 1239px;
    background: rgba(255, 255, 255, 0.85);
    box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
    border: 2px solid #ffffff;
    border-radius: 60px;
    margin: 0 auto;
    padding-top: 98px;
    margin-bottom: 180px;

    .results {
      display: block;
      width: 109px;
      margin: 0 auto;
    }

    .topTitle {
      font-size: 30px;
      font-weight: 500;
      color: #333333;
      text-align: center;
      margin-top: 46px;
    }

    .pic {
      width: 375px;
      height: 375px;
      background: rgba(0, 173, 163, 0.7);
      border-radius: 50%;
      line-height: 375px;
      text-align: center;
      font-size: 157px;
      font-weight: bold;
      color: #ffffff;
      margin: 0 auto;
      margin-top: 50px;
    }

    .pictxt {
      margin-top: 28px;
      font-size: 30px;
      font-weight: 500;
      color: #333333;
      text-align: center;
    }

    .pictxtall {
      margin-bottom: 103px;
      font-size: 30px;
      font-weight: 500;
      color: #333333;
      text-align: center;
    }

    .detailFooter {
      font-size: 30px;
      font-weight: 400;
      color: #333333;
      margin-top: 82px;
      padding: 0 40px;
      text-align: center;
      width: 100%;
      box-sizing: border-box;
    }

    .detail {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0px 112px;
      box-sizing: border-box;

      .text {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-items: center;
        font-size: 35px;
        font-weight: 500;
        color: #04397d;
      }

      .detailIcon {
        width: 127px;
        position: absolute;
        left: 0;
        top: 0;
      }
    }

    .flex {
      display: flex;
      margin: 0 32px;

      .left,
      .right {
        .top {
          font-size: 25px;
          font-weight: bold;
          color: #ab3b91;
        }

        .bottom {
          font-size: 25px;
          font-weight: bold;
          color: #4c4c4c;
        }
      }

      .right {
        margin-left: auto;
      }
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(234, 244, 243, 1) 100%
    );
    box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
    border-radius: 60px 60px 0px 0px;
    padding: 32px 0;

    .btn {
      width: 686px;
      margin: 0 auto;
      height: 80px;
      background: rgba(255, 255, 255, 1);
      border: 2px solid rgba(230, 230, 230, 1);
      line-height: 80px;
      font-size: 32px;
      font-weight: 400;
      border-radius: 8px;
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }

    .btns {
      width: 686px;
      margin: 0 auto;
      height: 80px;
      border-radius: 8px;
      background: linear-gradient(
        135deg,
        rgba(0, 187, 177, 1) 0%,
        rgba(0, 52, 127, 1) 100%
      );
      line-height: 80px;
      font-size: 32px;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      margin-top: 32px;
    }
  }
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(255, 255, 255, 0.8);
}

.dialog {
  width: 612px;
  height: 440px;
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;

  background: #ffffff;
  box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
  border-radius: 60px;

  .text {
    font-size: 35px;
    font-family: HarmonyOS Sans SC;
    font-weight: bold;
    color: #333333;
    line-height: 60px;
    text-align: center;
  }

  .mt130 {
    margin-top: 120px;
  }

  .btn {
    width: 247px;
    margin: 0 auto;
    height: 80px;
    line-height: 80px;
    text-align: center;
    font-size: 35px;
    font-family: HarmonyOS Sans SC;
    font-weight: 500;
    margin-top: 80px;
    color: #ffffff;
    border-radius: 40px;
    background: linear-gradient(
      132.74deg,
      rgba(0, 187, 177, 1) 0%,
      rgba(0, 86, 140, 1) 74.31%,
      rgba(171, 59, 127, 1) 100%
    );
  }
}

.zantingbox {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 11;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);

  .main {
    width: 550px;
    height: 700px;
    border-radius: 50px;
    background: rgba(255, 255, 255, 1);
    margin: 340px auto 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 244px;
      margin-top: 54px;
    }

    .zantingbox-suspend {
      width: 100%;
      text-align: center;
      margin-top: 30px;
      font-size: 44px;
      font-weight: 400;
      margin-bottom: 20px;
      color: rgba(51, 51, 51, 1);
    }

    .zantingbox-opportunity {
      width: 370px;
      text-align: center;
      margin: 25px auto 0;
      font-size: 30px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);

      span {
        color: rgba(247, 31, 31, 1);
        margin: 0 10rpx;
      }
    }

    .btn {
      width: 470px;
      height: 98px;
      border-radius: 49px;
      margin-top: 20px;
      background: linear-gradient(
        138.51deg,
        rgba(0, 187, 177, 1) 0%,
        rgba(0, 80, 137, 1) 79.86%,
        rgba(171, 59, 127, 1) 100%
      );
      font-size: 34px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 98px;
    }
  }
}
</style>
